import { ActivityType, SupportedFilterList } from './types';

export const supportedFilters: SupportedFilterList = [
  { field: 'sector', label: 'Sector' },
  { field: 'geography', label: 'Geography' },
  { field: 'activity_type', label: 'Activity type' },
  { field: 'isic_section', label: 'ISIC Section' },
  { field: 'isic_class', label: 'ISIC Class' },
];

export const supportedV4Filters: SupportedFilterList = [
  { field: 'sector', label: 'Sector' },
  { field: 'activity_type', label: 'Activity type' },
  { field: 'isic_section', label: 'ISIC Section' },
  { field: 'isic_class', label: 'ISIC Class' },
];

export const V4_ACTIVITY_TYPE_MAP: Record<string, ActivityType> = {
  'transforming activity': ActivityType.TRANSFORMING_ACTIVITY,
  'domestic supply mix': ActivityType.DOMESTIC_SUPPLY_MIX,
  'global supply mix': ActivityType.GLOBAL_SUPPLY_MIX,
  'supply mix': ActivityType.SUPPLY_MIX,
  'import mix': ActivityType.IMPORT_MIX,
};
